export class ReportSettings {
    altDerivativeMode: number;
    ignoreCurrentMileage: boolean;
    percentOverContractMileage: number;
    percentBelowContractMileage: number;
    daysAfterDiscontinuedDate: number;
    daysBeforeIntroducedDate: number;
}



// WEBPACK FOOTER //
// ./src/app/settings/models/report-settings.model.ts